export const LABELS = {
  DESCRIPTION: '',
  TITLE: 'Contact details',
  CONFIRM_MOBILE: 'We’ll send a secure code to your mobile number to protect your account.',
  CONFIRM_EMAIL: 'We’ll send a secure code to your email address to protect your account.',
  TEMP_PASSWORD:
    'A temporary password to your Brighte account will be emailed to you shortly. You can track the status, manage your application',
  OTP_SENT_SMS: 'We sent you an sms with a secure code. Please enter it below.',
  OTP_SENT_EMAIL: 'We sent you an email with a secure code. Please enter it below.',
  OTP_INVALID: 'Invalid secure code',
  UPDATE_EMAIL:
    'The email address in your account is %USER_EMAIL%. If you change it, you must verify by entering a code sent to your new email.',
  UPDATE_MOBILE:
    'The mobile number in your account ends with %USER_MOBILE%. If you change it, you must verify by entering a code sent via SMS to your new number.',
  CONTINUE: 'Continue',
  REQUEST_CODE: 'Request Code',
  OTP: 'Secure code',
  EMAIL: 'Email',
  MOBILE_NUMBER: 'Mobile number',
  WRONG_EMAIL_OTP: 'Wrong email or verification code.',
  WRONG_MOBILE_OTP: 'Wrong phone number or verification code.',
  MAX_ATTEMPTS: "You've reached the maximum number of attempts. Please try to login again.",
  UPDATE_MAX_ATTEMPTS: "You've reached your maximum attempts. Please request a new code",
};

export const BRIGHTE_ASSETS_URL = 'https://static-assets.prod.cloud.brighte.com.au';
